import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { userNotificationState } from './types'

const initialState: userNotificationState = {
  initialState: {},
  currentState: {},
}

type NotificationSettings = Record<string, boolean | string | undefined>

type UpdateCompanyPayload = {
  companyId: string
  settings: NotificationSettings
}

type UpdateUserPayload = {
  settings: NotificationSettings
}

const userNotificationSlice = createSlice({
  name: 'userNotification',
  initialState,
  reducers: {
    setInitialData: (state, { payload }) => {
      state.initialState = payload
      state.currentState = payload
    },
    updateCompany: (
      state,
      { payload }: PayloadAction<UpdateCompanyPayload>
    ) => {
      state.currentState = (state.currentState as any[]).map((company: any) =>
        company.id === payload.companyId
          ? { ...company, notificationSettings: payload.settings }
          : company
      )
    },
    updateUser: (state, { payload }: PayloadAction<UpdateUserPayload>) => {
      state.currentState = (state.currentState as any[]).map((company: any) =>
        company.id === 0
          ? { ...company, notificationSettings: payload.settings }
          : company
      )
    },
    resetToInitial: state => {
      state.currentState = state.initialState
    },
    reset: () => initialState,
  },
})

export const { actions, reducer: userNotification } = userNotificationSlice
export const {
  setInitialData,
  updateCompany,
  updateUser,
  resetToInitial,
  reset,
} = actions
